import axios from "axios";
import { APIURL } from "../Constantes";
import { getCabecera } from "../utils/getCabecera";
import { getError } from "../utils/errors";

const urlClient = "User/Client";

//* Método GET para interesados all
//* GET /api/User/Client/Interested/All
export const getInterestedClientAll = async () => {
    return await axios.get(
        `${APIURL}/${urlClient}/Interested/All`, {
        headers: getCabecera(),
    }
    ).then((response) => {
        return response.data
    }).catch((error) => {
        return []
    })
}

//* Método GET para interesados
//* GET /api/User/Client/Interested/{IdCliente}/{Pagina}/{Registros}
export const getInterestedClients = async ({ idCliente, pagina, registros }) => {
    return await axios.get(
        `${APIURL}/${urlClient}/Interested/${idCliente}/${pagina}/${registros}`, {
        headers: getCabecera(),
    }
    ).then((response) => {
        return response.data
    }).catch((error) => {
        return {}
    })
}

// Método GET para no interesados
export const getNoInterestedClients = async ({ pagina, registros }) => {
    return await axios.get(
        `${APIURL}/${urlClient}/NoInterested/${pagina}/${registros}`, {
        headers: getCabecera(),
    }
    ).then((response) => {
        return response.data;
    }).catch((error) => {
        return {}
    })
}

// Método PUT para marcar como interesado
export const markAsInterested = async (idCliente) => {
    return await axios.put(
        `${APIURL}/${urlClient}/Interested/${idCliente}`,
        {}, // Cuerpo vacío, pero puede modificarse si es necesario
        {
            headers: getCabecera(),
        }
    ).then((response) => {
        return response.data;
    }).catch((error) => {
        return getError(error);
    })
}

// Método PUT para marcar como no interesado
export const markAsNoInterested = async ({ idCliente }) => {
    return await axios.put(
        `${APIURL}/${urlClient}/NoInterested/${idCliente}`,
        {}, // Cuerpo vacío, pero puede modificarse si es necesario
        {
            headers: getCabecera(),
        }
    ).then((response) => {
        return response.data;
    }).catch((error) => {
        return getError(error);
    });
};
